<template>
  <v-container>
    <page-header :title="lang.regions" :info="lang.regionsInfo" />
    <v-card :class="['elevation-1']">
      <img v-if="$root.config.showRegionsMap" :src="$root.regionsMap" :class="['elevation-1', 'map', 'mx-2', 'mt-2']" usemap="#statemap" />
      <map name="statemap">
        <area :class="['item-clickable']" v-for="(region, index) in $root.regions" shape="poly" :key="index" :coords="region.coords" :title="region.label.cyrillic" @click="goToResource('/regions', region.id)" />
      </map>
      <v-list :class="['mx-2']">
        <v-list-tile ripple :to="`/regions/${region.id}`" v-for="region in regions" :title="lang.moreInfoAboutTheBandsInRegion(region.label.cyrillic)" :key="region.label.cyrillic">
          <v-list-tile-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="region.label.cyrillic" />
          </v-list-tile-content>
          <chevron-right />
        </v-list-tile>
      </v-list>
    </v-card>
    <div hidden v-html="lang.regionsInfo" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'regions',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      regions: []
    }
  },
  mounted () {
    this.regions = this.$root.regions
    this.$nextTick(() => {
      this.emitRouteChange()
      this.setLastBreadcrumbsItemText(lang.regions)
    })
  }
}
</script>
<style>
.map
{
  max-width: 100%;
  height: auto;
  filter: contrast(102%) sepia(0%) saturate(500%) hue-rotate(0deg) invert(0%) opacity(100%) grayscale(100%) blur(0px);
}
</style>



// WEBPACK FOOTER //
// src/pages/regions.vue